"use client";

import { motion } from "framer-motion";

interface RegenerateIconProps {
  /** Increment on each click to trigger animation. 0 = static on mount. */
  triggerKey: number;
}

export function RegenerateIcon({ triggerKey }: RegenerateIconProps) {
  const shouldAnimate = triggerKey > 0;

  return (
    <motion.svg
      key={triggerKey}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-4 text-inherit"
      initial={shouldAnimate ? { scale: 1 } : false}
      animate={shouldAnimate ? { scale: [1, 0.92, 1.06, 1] } : {}}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    >
      <path
        className="stroke-current"
        d="M6.40039 4.07474C6.61498 3.53064 7.385 3.53064 7.5996 4.07474L8.20687 5.6144C8.59993 6.6111 9.38887 7.40007 10.3856 7.79313L11.9253 8.4004C12.4693 8.615 12.4693 9.385 11.9253 9.5996L10.3856 10.2069C9.38887 10.5999 8.59993 11.3889 8.20687 12.3856L7.5996 13.9253C7.385 14.4693 6.61498 14.4693 6.40039 13.9253L5.79316 12.3856C5.40007 11.3889 4.6111 10.5999 3.6144 10.2069L2.07474 9.5996C1.53064 9.385 1.53064 8.615 2.07474 8.4004L3.6144 7.79313C4.6111 7.40007 5.40007 6.6111 5.79316 5.6144L6.40039 4.07474Z"
      />
      <motion.g
        style={{ transformOrigin: "12.33px 3.67px" }}
        initial={shouldAnimate ? { rotate: 0 } : false}
        animate={shouldAnimate ? { rotate: 360 } : {}}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      >
        <path
          className="stroke-current"
          d="M12.1085 1.81969C12.1889 1.61566 12.4777 1.61566 12.5582 1.81969L12.7859 2.39707C12.9333 2.77083 13.2292 3.06669 13.6029 3.2141L14.1803 3.44181C14.3843 3.52229 14.3843 3.81105 14.1803 3.89152L13.6029 4.11923C13.2292 4.26664 12.9333 4.56251 12.7859 4.93627L12.5582 5.51364C12.4777 5.71767 12.1889 5.71767 12.1085 5.51364L11.8808 4.93627C11.7333 4.56251 11.4375 4.26664 11.0637 4.11923L10.4863 3.89152C10.2823 3.81105 10.2823 3.52229 10.4863 3.44181L11.0637 3.2141C11.4375 3.06669 11.7333 2.77083 11.8808 2.39707L12.1085 1.81969Z"
        />
      </motion.g>
    </motion.svg>
  );
}
